import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { FabricFileIconComponent } from "./fabric-file-icon.component";
import { FabricFileIconService } from "./fabric-file-icon.service";

@NgModule({
	declarations: [FabricFileIconComponent],
	imports: [CommonModule],
	exports: [FabricFileIconComponent],
})
export class FabricFileIconModule {
	static forRoot(): ModuleWithProviders<FabricFileIconModule> {
		return {
			ngModule: FabricFileIconModule,
			providers: [FabricFileIconService],
		};
	}
}
